import styled from 'styled-components';

export const DescriptionContainer = styled.div``;

export const DescriptionHeader = styled.div`
  ${(props) => props.theme.newTypography.textStyleHeading}

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin: 25px 0 10px 0;
  }
`;

export const DescriptionText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
`;

export const FileUploadContainer = styled.div`
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  height: min-content;
  color: ${(props) => props.theme.newPalette.neutral.N0};
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  text-decoration: none;
  display: flex;
  padding: 25px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-radius: 0;
    box-shadow: none;
    width: 100%;
    padding: 0;
    margin-top: 0;
  }
`;

export const AdditionalEvidenceHeader = styled.div`
  ${(props) => props.theme.newTypography.textStyleHeading}
  margin: 24px 0 12px 0;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin: 25px 0 10px 0;
  }
`;
